


















































































































import Message from '@/types/Message.interface'
import { mapGetters } from 'vuex'
import Vue, { PropType } from 'vue'
import SmsInboundBubble from '@/components/SmsInboundBubble.vue'
import SmsOutboundBubble from '@/components/SmsOutboundBubble.vue'
import { popPreview } from '@/utility/helpers'
import Media from '@/types/Media.interface'
import User from '@/types/User.interface'
import UserLogo from '@/components/UserLogo.vue'
import Button from '@/types/components/Button.interface'
import SlidingAlert from '@/components/SlidingAlert.vue'
export default Vue.extend({
    components: { SmsInboundBubble, SlidingAlert, SmsOutboundBubble, UserLogo },
    props: {
        fullWidth: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            required: true
        },
        message: {
            type: Object as PropType<Message>,
            required: true
        }
    },
    computed: {
        ...mapGetters(['isApp', 'persons', 'users']),
        bubbleColor(): string {
            //  If this is NOT a comment, return null
            if (!this.comment) return null

            //  If this is a comment, our typing will be comment.type or default to itself
            const type = this.message.comment.type

            //  Grab our color based on this type
            const color =
                {
                    autoresponder: '#4D4D4D',
                    broadcast: '#4D4D4D',
                    form: '#4D4D4D',
                    invoice: this.$colors.mdPurple70,
                    'office hours': '#4D4D4D',
                    chatbot: '#4D4D4D',
                    consent: '#4D4D4D',
                    send: this.$colors.mdPurple70
                }[type] || this.$colors.mdPurple70

            //  Return our color
            return color
        },
        caratStyle(): object {
            return {
                position: 'absolute',
                top: '-10px',
                left: '15px',
                filter: 'drop-shadow(0 -2.5px 0 rgba(0, 0, 0, 0.25))',
                'border-color': `transparent transparent #e0e0e0 transparent`,
                'border-style': 'solid',
                'border-width': '0 12px 12px 12px'
            }
        },
        chatbotComment(): boolean {
            //  If the comment has no text return false, return null
            if (!this.message.text) return false

            //  Chatbot submission specific comments have this keyword in them that we use as a 'title'
            //  it's also what allows us to tell the difference between a normal comment and a chatbot comment
            //  We cannot use the comment column as the client expects an array of numbers and changing type or status removes comment formatting
            if (this.message.text.includes("Chatbot Submission")) return true

            return false
        },
        comment(): boolean {
            //  If we don't have a comment, return false
            if (!this.message.comment) return false

            //  Else, if we don't have a comment response, return false
            if (!this.message.comment.response) return false

            //  Else, return true
            return true
        },
        commentIcon(): string {
            //  If this is NOT a comment, return null
            if (!this.comment) return null

            //  If this is a comment, our typing will be comment.type or default to itself
            const type = this.message.comment.type

            //  Icon depends on type of message
            const icon =
                {
                    autoresponder: 'bi-lightning-fill',
                    broadcast: 'mdi-bullhorn',
                    form: 'mdi-form-select',
                    invoice: 'bi-cash',
                    'office hours': 'mdi-clock',
                    chatbot: 'bi-chat-square-fill',
                    consent: 'mdi-message-lock'
                }[type] || 'mdi-account'

            //  Return our icon
            return icon
        },
        commentTooltip(): string {
            //  If this is NOT a comment, return null
            if (!this.comment) return null

            //  If this is a comment, our typing will be comment.type or default to itself
            const type = this.message.comment.type

            //  Get our tooltip
            const tooltip =
                {
                    autoresponder: 'Autoresponder',
                    broadcast: 'Broadcast',
                    form: 'Form',
                    invoice: 'Invoice',
                    'office hours': 'Office Hours',
                    chatbot: 'Chatbot',
                    consent: 'Consent'
                }[type] || this.commentUser?.firstname

            //  Return the tooltip
            return tooltip
        },
        commentUser(): User {
            //  If this is not a comment, return null
            if (!this.comment) return null

            //  Grab the comment author id
            const authorId = this.message.comment.author_id

            //  If the message does NOT have an author_id, return null
            if (!authorId) return null

            //  Get the message's author/person (persons related to Users are loaded in initial state requests in AppSync::onTenantSet)
            const author = this.persons.find((x) => x.id === authorId)

            //  If the author does NOT exist, return null (this can occur in a race condition when initial state is still loading)
            if (!author) return null

            //  Get the user
            const user = this.users.find((x) => x.id === author.user_id)

            //  Return the user bound to the message author
            return user
        },
        formComment(): boolean {
            //  If the comment has no text return false, return null
            if (!this.message.text) return false

            //  Form submission specific comments have this keyword in them that we use as a 'title'
            //  it's also what allows us to tell the difference between a normal comment and a form comment
            //  We cannot use the comment column as the client expects an array of numbers and changing type or status removes comment formatting
            if (this.message.text.includes("Form Submission")) return true

            return false
        },
        hoverButtons(): Button[] {
            //  Create our array of buttons
            return [
                {
                    icon: 'bi-front',
                    color: 'white',
                    tooltip: 'Copy to Clipboard',
                    hidden: !this.message.text,
                    callback: () => this.copyMessage()
                },
                {
                    icon: 'bi-trash-fill',
                    color: 'white',
                    tooltip: 'Delete Message',
                    disabledPopup: this.operator,
                    callback: () => this.deleteMessageConfirm()
                }
                // {
                //     icon: 'bi-circle-fill',
                //     color: 'primary',
                //     callback: () => console.log('MARK AS NEW')
                // },
                // {
                //     icon: 'bi-translate',
                //     color: 'white',
                //     callback: () => console.log('TRANSLATE')
                // }
            ]
        },
        hoverStyle(): object {
            //  Return the parsed styles
            return {
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                position: 'absolute',
                top: '-40px',
                left: 0,
                right: 0,
                'margin-left': 'auto',
                'margin-right': 'auto',
                height: '40px',
                width: '220px',
                'border-radius': '10px',
                filter: 'drop-shadow(0 2px 2px #000)',
                'background-color': '#e0e0e0',
                'z-index': 1
            }
        },
        messageReceipt(): string {
            //  Date will be created_at, or delivered if it was delivered
            const date = this.$options.filters.chatDate(this.message.updated_at)

            //  Our status is either our message status in proper case, or 'Sent'
            const status = 'Commented'

            //  Return the report + the chatDate
            return `${status} ${date}`
        },
        messageUser(): User | null {
            //  If the message does NOT have an author_id, return null (this occurs when the message was created by the system, rather than user)
            if (!this.message.author_id) return null

            //  Get the message's author/person (persons related to Users are loaded in initial state requests in AppSync::onTenantSet)
            const author = this.persons.find((x) => x.id === this.message.author_id)

            //  If the author does NOT exist, return null (this can occur in a race condition when initial state is still loading)
            if (!author) return null

            //  Get the user
            const user = this.users.find((x) => x.id === author.user_id)

            //  Return the user bound to the message author
            return user
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        parsedCommentText(): string {
            //  Grab our message comment
            const comment = this.message.comment

            //  If no comment, return null
            if (!comment) return null

            //  Else, grab our response text
            const text = comment.response

            //  If our text is MMS or null, return null
            if (!text || text === 'MMS') return null

            //  Else, parse the text
            const parsed = this.$options.filters.parseMessageText(text, false)

            //  Return parsed
            return parsed
        },
        parsedMessageText(): string {
            //  Grab our message text
            const txt = this.message.text

            //  Parse the text
            const parsed = this.$options.filters.parseMessageText(txt, false, true)

            //  Return the parsed
            return parsed
        },
        validRoute(): boolean {
            //  Only return true if our path contains inbox OR teammates
            return (
                this.$route.path.includes('inbox') ||
                this.$route.path.includes('teammates')
            )
        }
    },
    methods: {
        copyMessage(): void {
            //  Create a temporary input to store our data
            const input = document.createElement('textarea')

            //  Add our input to the DOM
            document.body.appendChild(input)

            //  Get our parsed text
            const text = this.$options.filters.parseCommentedText(
                this.message.text,
                false
            )

            //  Set the value of this input to our message text
            input.value = text

            //  Focus our input
            input.focus()

            //  Select the text in our input (message text)
            input.select()

            //  Copy the text to clipboard
            document.execCommand('Copy')

            //  Remove our input now that we copied text
            input.remove()

            //  Notify our user with toast :)
            this.$store.commit('appNotificationBarSet', {
                message: 'Message Text Copied to Clipboard!',
                type: 'success'
            })
        },
        deleteMessageConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Message',
                text: `Are you sure you'd like to delete this message? If yes, it will be removed from the conversation history`,
                icon: 'mdi-alert',
                color: 'primary',
                callback: (result: boolean) => this.deleteMessage(result)
            })
        },
        async deleteMessage(result: boolean): Promise<void> {
            //  If no result, do nothing
            if (!result) return

            // Else, delete the failed message
            const resp = await this.$store.dispatch('messagesDelete', this.message)
        },
        popPreview(media: Media): void {
            popPreview(media)
        }
    }
})
